import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import CloneIcon from '../../../../../../themes/svg/cloneIcon';
import CaretIcon from '../../../../../../themes/svg/chevronUp';

class DuplicateItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      numberOfTimes: 2,
    };
  }

  onKeyDownForNumberOfTimes = (event) => {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.dupeThisItemMany();
    }
  }

  onNumberChange = (e) => {
    this.setState({ numberOfTimes: this.parseNumberOfTimes(e.target.value) });
  };

  dupeThisItem = () => {
    if (!this.state.isOpen) {
      this.props.copyItem(this.props.itemId);
    }
  };

  dupeThisItemMany = () => {
    if (this.state.isOpen && !this.state.numberOfTimes < 1) {
      this.props.copyItems(this.props.itemId, this.state.numberOfTimes);
      this.toggleOpen();
    }
  };

  parseNumberOfTimes = (val) => {
    const newVal = Math.round(parseFloat(val));
    if (!isNaN(newVal)) {
      return newVal < 1 ? 1 : newVal;
    }
    return '';
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return (
      <div className="actionBarItem">
        <div
          className={classNames('actionBarIcon', this.state.isOpen ? 'disabled' : '')}
          onClick={this.dupeThisItem}
          role="button"
          tabIndex="-1"
        >
          <CloneIcon />
        </div>
        <span
          className={classNames('label link', this.state.isOpen ? 'disabled' : '')}
          onClick={this.dupeThisItem}
          role="button"
          tabIndex="-1"
        >
          Duplicate
        </span>
        <div className={classNames('duplicateAmount desktop-tablet-only', this.state.isOpen ? 'open' : '')}>
          <input
            type="number"
            value={this.state.numberOfTimes}
            min="1"
            onChange={e => this.onNumberChange(e)}
            onKeyDown={this.onKeyDownForNumberOfTimes}
            title="How many times do you want to duplicate this item?"
          />
          <button
            className={classNames('btn btn-primary', this.state.numberOfTimes < 1 ? 'disabled' : '')}
            onClick={this.dupeThisItemMany}
            disabled={this.state.numberOfTimes < 1}
            title="How many times do you want to duplicate this item?"
          >
            &nbsp;
          </button>
        </div>
        <div
          className={classNames('caret desktop-tablet-only', this.state.isOpen === true ? 'open' : '')}
          role="button"
          tabIndex="-1"
          onClick={this.toggleOpen}
          title={this.state.isOpen === false ? 'Advance Duplicate' : 'Cancel'}
        >
          <CaretIcon />
        </div>
      </div>
    );
  }
}

DuplicateItem.propTypes = {
  itemId: PropTypes.string.isRequired,
  copyItem: PropTypes.func.isRequired,
  copyItems: PropTypes.func.isRequired,
};

export default DuplicateItem;
